export const SEASON_LABEL_PROPERTIES = [  { key: "season", type: "Long" },];
export interface SeasonProperties {
  season: number;
}